<template>
  <div class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8">
    <div class="font-mono">
      <span class="font-bold text-red-600 text-xl" v-if="isTestEnvironment">
        JE BENT MOMENTEEL IN DE TEST OMGEVING!!!
      </span>
      <span v-else>{{ greeting }}, collega!</span>
    </div>

    <div class="ml-auto flex items-center">
      <RouterLink :to="{ name: 'Admin.Information' }" class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-sm font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset">
        v{{ version }}
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { version } from '@/main'

const isTestEnvironment = computed(() => window.location.hostname.includes("forms-test"));

const greeting = computed(() => {
  const hour = new Date().getHours();

  if (hour >= 0 && hour < 6) return "Goedenacht";
  if (hour >= 6 && hour < 12) return "Goedemorgen";
  if (hour >= 12 && hour < 18) return "Goedemiddag";

  return "Goedeavond";
});
</script>